 


import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router'; 

import { AgencyComponent } from './agency.component';
import { AddagentComponent } from './addagent.component'; 
import { AddagentpicComponent } from './addagentpic.component'; 
import { AddagentceoComponent } from './addagentceo.component'; 
import { ViewagentComponent } from './viewagent.component';

import { BroadcastComponent } from './broadcast.component';

import { ViewreporequestComponent } from './viewreporequest.component';
import { ReporequestComponent } from './reporequest.component';
import { RepoComponent } from './repo.component';
import { RepossessedComponent } from './repossessed.component'; 
/*
import { AssignedComponent } from './assigned.component';
import { ExpiredComponent } from './expired.component'; 
import { ChangeagentComponent } from './changeagent.component'; 
import { ViewagentperformanceComponent } from './viewagentperformance.component'; 
import { RepoagencyComponent } from './repoagency.component'; 
import { ViewrepoagentComponent } from './viewrepoagent.component';
import { AddrepoagentComponent } from './addrepoagent.component'; 
import { Addrepoagent2Component } from './addrepoagent2.component'; 
import { Addrepoagent3Component } from './addrepoagent3.component';  
import { EditagentComponent } from './editagent.component'; 
import { Editagent2Component } from './editagent2.component'; 
import { Editagent3Component } from './editagent3.component'; 
import { AgencyassignmentComponent } from './agencyassignment.component'; 
import { DiscountrequestedComponent } from './discountrequested.component';
*/
// Auth
import { AuthGuard } from '../_guards/index';

const routes: Routes = [
  {
    path: '',
    data: {
      title: 'Agencies'
    }, 
    canActivate: [AuthGuard],
    children: [
       
      {
        path: 'agency',
        component: AgencyComponent, 
        data: {
          title: 'Agency'
        }
      },
      {
        path: 'agency/:id',
        component: AgencyComponent, 
        data: {
          title: 'Agency'
        }
      },
      {
        path: 'viewagent/:id',
        component: ViewagentComponent,
        data: {
          title: 'Agency'
        }
      }, 
      {
        path: 'addagent',
        component: AddagentComponent, 
        data: {
          title: 'Add Agency' 
        }
      },
      {
        path: 'addagentpic/:id',
        component: AddagentpicComponent, 
        data: {
          title: 'Add Agency PIC' 
        }
      },
      {
        path: 'addagentceo/:id',
        component: AddagentceoComponent, 
        data: {
          title: 'Add Agency' 
        }
      },
      {
        path: 'broadcast',
        component: BroadcastComponent, 
        data: {
          title: 'Broadcast' 
        }
      },
      {
        path: 'viewreporequest/:id',
        component: ViewreporequestComponent, 
        data: {
          title: 'View Repo Request' 
        }
      },
      {
        path: 'reporequest',
        component: ReporequestComponent, 
        data: {
          title: 'Repo Request' 
        }
      },
      {
        path: 'repo',
        component: RepoComponent, 
        data: {
          title: 'Repo Broadcast' 
        }
      },
      {
        path: 'repossessed',
        component: RepossessedComponent, 
        data: {
          title: 'Repossessed' 
        }
      }   


       
    ] 
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],  
  exports: [RouterModule]
})
export class RepoagenciesRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/repoagencies/repoagencies-routing.module.ts